import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useState, useEffect } from 'react'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Comercios from './pages/Comercios'
import ComercioDetalle from './pages/ComercioDetalle'
import Solicitudes from './pages/Solicitudes'
import Pagos from './pages/Pagos'
import Layout from './components/Layout'
// Portal Público de Pagos
import PortalPagos from './pages/PortalPagos'
import EstadoPago from './pages/EstadoPago'

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Verificar si hay token guardado
    const token = localStorage.getItem('token')
    if (token) {
      setIsAuthenticated(true)
    }
    setLoading(false)
  }, [])

  const handleLogin = (token, usuario) => {
    localStorage.setItem('token', token)
    localStorage.setItem('usuario', JSON.stringify(usuario))
    setIsAuthenticated(true)
  }

  const handleLogout = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('usuario')
    setIsAuthenticated(false)
  }

  if (loading) {
    return (
      <div className="loading" style={{ height: '100vh' }}>
        <div className="spinner"></div>
      </div>
    )
  }

  return (
    <BrowserRouter>
      <Routes>
        {/* =============================================
            RUTAS PÚBLICAS - Portal de Pagos
            Sin autenticación requerida
            ============================================= */}
        <Route path="/pagar" element={<PortalPagos />} />
        <Route path="/estado-pago" element={<EstadoPago />} />

        {/* =============================================
            RUTAS DEL GESTOR - Con autenticación
            ============================================= */}

        {/* Ruta de login */}
        <Route
          path="/login"
          element={
            isAuthenticated
              ? <Navigate to="/" replace />
              : <Login onLogin={handleLogin} />
          }
        />

        {/* Rutas protegidas */}
        {isAuthenticated ? (
          <Route element={<Layout onLogout={handleLogout} />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/comercios" element={<Comercios />} />
            <Route path="/comercios/:id" element={<ComercioDetalle />} />
            <Route path="/solicitudes" element={<Solicitudes />} />
            <Route path="/pagos" element={<Pagos />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        ) : (
          <Route path="*" element={<Navigate to="/login" replace />} />
        )}
      </Routes>
    </BrowserRouter>
  )
}

export default App
